
var moment = require('moment');
var Registry = require('registry');


/**
 * Ein Datum parsen und ein moment-Objekt zurückgeben
 */
var parseDate = function(d, reset) {
	if ( d === null ) return null;
	let result;

	if ( d instanceof Date ) {
		result = moment(d);
	} else {
		result = moment(d, [
			'L',
			'DD.MM.YY',
			'DD.MM.YYYY',
			'YYYY-MM-DD',
		]);
	}
	return reset ? resetTimeFields(result) : result;
};


/**
 * Render a string for the from - to period.
 *  @todo t10n, i18n
 */
var textPeriod = function(from, to, nights, select_mode) {
	var m_from = moment(from, 'YYYY-MM-DD');
	var m_to = moment(to, 'YYYY-MM-DD');
	var now = moment();
	var shortmode = Registry.get("DateTime.ShortTextPeriod", false);
	select_mode = select_mode || "exact";

	if ( !from || !m_from.isValid() ) { return __("no_date"); }
	if ( !to || !m_to.isValid() ) { return m_from.format("dd. DD.MM.YYYY") + " bis ..."; }

	var date_to = " " + __("date_to") + " ";

	/* Standard */
	var result = m_from.format("DD.MM.YYYY") + date_to + m_to.format("DD.MM.YYYY");
	var weekdays = m_from.format("dd") + "-" + m_to.format("dd");

	/* Bei gleichem Jahr dieses ausblenden */
	if ( m_from.year() === m_to.year() && m_from.year() === now.year() ) {
		result = m_from.format("DD.MM.") + date_to + m_to.format("DD.MM.YYYY");
	}

	/* Gleicher Monat, aktuelles Jahr */
	if ( m_from.month() === m_to.month() && m_from.year() === now.year() ) {
		result = m_from.format("DD.") + date_to + m_to.format("DD. MMMM");
	}

	/* Gleicher Monat, anderes Jahr */
	if ( m_from.month() === m_to.month() && m_from.year() !== now.year() ) {
		result = m_from.format("DD. ") + date_to + m_to.format("DD. MMMM YYYY");
	}

	/* Nächte */
	nights = nights || m_to.diff(m_from, 'days');
	var nights_part;
	if ( nights === 1 ) {
		nights_part = __("one_night");
	} else {
		nights_part = __("x_nights", {nights: nights});
	}

	if ( select_mode === "flex" ) {
		result = nights_part + " im Zeitraum " + result;
	}
	else if ( !shortmode ) {
		result = result + ", " + nights_part + " (" + weekdays + ")";
	}

	var guard = 10;
	while ( result.indexOf('  ') !== -1 ) {
		result = result.replace('  ', ' '); // Safari is the new IE
		guard--;
		if ( guard <= 0 ) break;
	}
	return result;
}


/**
 * Reset all time fields of a Date object to zero (hour, minute, second, msec)
 */
var resetTimeFields = function(date) {
	if ( moment.isMoment(date) ) {
		date.hours(0);
		date.minutes(0);
		date.seconds(0);
		date.milliseconds(0);
	} else {
		date.setHours(0);
		date.setMinutes(0);
		date.setSeconds(0);
		date.setMilliseconds(0);
	}
	return date;
};


module.exports = {
	parse: parseDate,
	moment: moment,
	textPeriod: textPeriod,
	resetTimeFields: resetTimeFields,
};



/** WEBPACK FOOTER **
 ** /Users/mitch/jsapps/modules/DateTime.js
 **/